import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import dataReducer from '../reducers/data.reducer';
import uiReducer from '../reducers/ui.reducer';
import authReducer from '../reducers/auth.reducer';
import fileReducer from '../reducers/file.reducer';
import examinationReducer from '../reducers/examination.reducer';

const rootReducer = combineReducers({
  data: dataReducer,
  ui: uiReducer,
  auth: authReducer,
  files: fileReducer,
  examination: examinationReducer
});

export const store = createStore(rootReducer, applyMiddleware(thunk));
